import script from "./FirstView.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstView.vue?vue&type=script&setup=true&lang=js"

import "./FirstView.vue?vue&type=style&index=0&id=1fd61c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd61c56"]])

export default __exports__